// import {
//   collection,
//   query,
//   where,
//   getCountFromServer,
//   getAggregateFromServer,
//   getDocs,
//   sum,
//   getDoc,
//   // doc,
//   // startAt,
//   orderBy,
//   updateDoc,
//   doc,
//   // limit
// } from "firebase/firestore";
// import { db } from "../firebase";

// export default class User {
//   constructor() {
//     this.KEY = "User";
//   }
//   async users(days) {
//     try {
//       if (days) {
//         const date = new Date();
//         date.setDate(date.getDate() - days);
//         const coll = collection(db, this.KEY);
//         const q = query(coll, where("createdAt", "<=", date));
//         const snapshot = await getCountFromServer(q);
//         return snapshot.data().count;
//       }
//       const coll = collection(db, this.KEY);
//       const snapshot = await getDocs(coll);
//       return await snapshot.size;
//     } catch (error) {
//       console.error(error);
//     }
//   }
//   async serviceProviders(category) {
//     try {
//       const coll = collection(db, this.KEY);
//       const q = query(
//         coll,
//         where("role", "==", "provider"),
//         where("category", "==", category)
//       );
//       const snapshot = await getDocs(q);
//       return snapshot.size;
//     } catch (error) {
//       console.error(error, { category });
//     }
//   }
//   async businessEarn(days) {
//     try {
//       if (days) {
//         const date = new Date();
//         date.setDate(date.getDate() - days);
//         const coll = collection(db, this.KEY);
//         const q = query(
//           coll,
//           where("role", "==", "provider"),
//           where("createdAt", "<=", date)
//         );
//         const snapshot = await getAggregateFromServer(q, {
//           total: sum("amount"),
//         });
//         return snapshot.data().total;
//       }
//       const coll = collection(db, this.KEY);
//       const q = query(coll, where("role", "==", "provider"));
//       const snapshot = await getAggregateFromServer(q, {
//         total: sum("amount"),
//       });
//       return await snapshot.data().total;
//     } catch (error) {
//       console.error(error);
//     }
//   }
//   async allUsers() {
//     try {
//       const coll = collection(db, this.KEY);
//       const q = query(coll, orderBy("createdAt"));
//       const snapshot = await getDocs(q);
//       const data = [];
//       snapshot.forEach((ele) => {
//         data.push(ele.data());
//       });
//       return await data;
//     } catch (error) {
//       console.error(error);
//     }
//   }
//   async allServiceProviders() {
//     let data = [];
//     try {
//       const querySnapshot = await getDocs(
//         query(collection(db, this.KEY), where("role", "==", "provider"))
//       );

//       querySnapshot.forEach((doc) => {
//         console.log(doc.id, " => ", doc.data());
//         data.push({ ...doc.data(), id: doc.id });
//       });
//       return data;
//     } catch (error) {
//       console.log(error);
//       return [];
//     }
//   }

//   async allClients() {
//     let data = [];
//     try {
//       const querySnapshot = await getDocs(
//         query(collection(db, this.KEY), where("role", "==", "client"))
//       );

//       querySnapshot.forEach((doc) => {
//         console.log(doc.id, " => ", doc.data());
//         data.push({ ...doc.data(), id: doc.id });
//       });
//       return data;
//     } catch (error) {
//       console.log(error);
//       return [];
//     }
//   }
//   async updateUser(key, data) {
//     try {
//       await updateDoc(doc(db, this.KEY, key), data);
//     } catch (error) {
//       console.error(error);
//     }
//   }
//   async findUser(phone_number) {
//     try {
//       let r = await (await getDoc(doc(db, this.KEY, phone_number))).data();
//       return r;
//     } catch (error) {
//       console.error(error);
//     }
//   }
//   async authenticate(email, password) {
//     // 1. build the query
//     const coll = collection(db, this.KEY);
//     const q = query(
//       coll,
//       where("email", "==", email),
//       where("password", "==", password)
//     );

//     // 2. run it
//     const snapshot = await getDocs(q);

//     if (snapshot.empty) {
//       throw new Error("Invalid credentials");
//     }

//     // 3. pick the first doc
//     const userData = snapshot.docs[0].data();

//     if (userData.role !== "admin") {
//       throw new Error("Not an admin");
//     }

//     return userData;
//   }

//   async changePassword(email, oldPassword, newPassword) {
//     const coll = collection(db, this.KEY);
//     const q = query(coll, where("email", "==", email));
//     const snap = await getDocs(q);

//     if (snap.empty) {
//       throw new Error("User not found");
//     }

//     const docSnap = snap.docs[0];
//     const userData = docSnap.data();

//     if (userData.password !== oldPassword) {
//       throw new Error("Incorrect current password");
//     }

//     if (oldPassword === newPassword) {
//       throw new Error("New password must differ from the old one");
//     }

//     await updateDoc(doc(db, this.KEY, docSnap.id), {
//       password: newPassword,
//     });
//   }
// }


import {
  collection,
  query,
  where,
  getCountFromServer,
  getAggregateFromServer,
  getDocs,
  sum,
  getDoc,
  orderBy,
  updateDoc,
  doc,
  Timestamp,
} from "firebase/firestore";
import { db } from "../firebase";

export default class User {
  constructor() {
    this.KEY = "User";
  }

  async users(days) {
    try {
      const coll = collection(db, this.KEY);

      if (days) {
        const date = new Date();
        date.setDate(date.getDate() - days);
        const ts = Timestamp.fromDate(date);

        // count users created within last X days
        const q = query(coll, where("createdAt", ">=", ts));
        // >
        const snapshot = await getCountFromServer(q);
        return snapshot.data().count;
      }

      // total users
      const snapshot = await getCountFromServer(coll);
      return snapshot.data().count;
    } catch (error) {
      console.error(error);
      return 0;
    }
  }

  async serviceProviders(category) {
    try {
      const coll = collection(db, this.KEY);
      const q = query(
        coll,
        where("role", "==", "provider"),
        where("category", "==", category)
      );
      const snapshot = await getDocs(q);
      return snapshot.size;
    } catch (error) {
      console.error(error, { category });
      return 0;
    }
  }

  async businessEarn(days) {
    try {
      const coll = collection(db, this.KEY);

      if (days) {
        const date = new Date();
        date.setDate(date.getDate() - days);
        const ts = Timestamp.fromDate(date);

        const q = query(
          coll,
          where("role", "==", "provider"),
          where("createdAt", ">=", ts)
        );

        const snapshot = await getAggregateFromServer(q, {
          total: sum("amount"),
        });

        return snapshot.data().total ?? 0;
      }

      const q = query(coll, where("role", "==", "provider"));
      const snapshot = await getAggregateFromServer(q, {
        total: sum("amount"),
      });
      return snapshot.data().total ?? 0;
    } catch (error) {
      console.error(error);
      return 0;
    }
  }

  async allUsers() {
    try {
      const coll = collection(db, this.KEY);
      const q = query(coll, orderBy("createdAt"));
      const snapshot = await getDocs(q);
      const data = [];
      snapshot.forEach((ele) => {
        data.push(ele.data());
      });
      return data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async allServiceProviders() {
    let data = [];
    try {
      const querySnapshot = await getDocs(
        query(collection(db, this.KEY), where("role", "==", "provider"))
      );
      querySnapshot.forEach((docSnap) => {
        data.push({ ...docSnap.data(), id: docSnap.id });
      });
      return data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async allClients() {
    let data = [];
    try {
      const querySnapshot = await getDocs(
        query(collection(db, this.KEY), where("role", "==", "client"))
      );
      querySnapshot.forEach((docSnap) => {
        data.push({ ...docSnap.data(), id: docSnap.id });
      });
      return data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  async updateUser(key, data) {
    try {
      await updateDoc(doc(db, this.KEY, key), data);
    } catch (error) {
      console.error(error);
    }
  }

  async findUser(phone_number) {
    try {
      let r = await (await getDoc(doc(db, this.KEY, phone_number))).data();
      return r;
    } catch (error) {
      console.error(error);
    }
  }

  async authenticate(email, password) {
    const coll = collection(db, this.KEY);
    const q = query(
      coll,
      where("email", "==", email),
      where("password", "==", password)
    );
    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      throw new Error("Invalid credentials");
    }

    const userData = snapshot.docs[0].data();

    if (userData.role !== "admin") {
      throw new Error("Not an admin");
    }

    return userData;
  }

  async changePassword(email, oldPassword, newPassword) {
    const coll = collection(db, this.KEY);
    const q = query(coll, where("email", "==", email));
    const snap = await getDocs(q);

    if (snap.empty) {
      throw new Error("User not found");
    }

    const docSnap = snap.docs[0];
    const userData = docSnap.data();

    if (userData.password !== oldPassword) {
      throw new Error("Incorrect current password");
    }

    if (oldPassword === newPassword) {
      throw new Error("New password must differ from the old one");
    }

    await updateDoc(doc(db, this.KEY, docSnap.id), {
      password: newPassword,
    });
  }
}
